import { IAIPromptHistoryData } from 'components/AIPromptHistory'

export interface ICheckListDetail {
  accept?: boolean
  note?: string
  ai?: IAIPromptHistoryData
  responsibility?: string
}
export interface ICheckListData {
  detail: Record<string, ICheckListDetail>
  [key: string]: string | any
}

export type ConditionNoteType = 'note' | 'internalNote' | 'aiNote'

export interface LoanSubmissionCondition {
  id: number
  no: number
  name: string
  type: string
  intext: boolean
  category: string
  createdAt: string
  updatedAt: string
  documentCategory: string
  description: string
  brokerDescription?: string
  responsibility: string
  note?: string
  borrowerNote?: string
  internalNote?: string
  aiNote?: string
  ConditionID?: number
  cleared?: boolean
  clearedBy?: string
  clearedDate?: string

  exception?: boolean
  exceptionBy?: string
  exceptionDate?: string
  exceptionStatus?: number

  requested?: boolean
  requestedBy?: string
  requestedDate?: string
  requestedTo?: string

  checklist: ICheckListData

  [key: string]: any
}

export interface LoanSubmissionDocument {
  DocumentID?: number
  key: string
  name: string
  status: string
  category: string
  createdAt: number
  isEditing?: boolean
  conditionNo: number
  generated?: boolean
  intext?: boolean
  borrower?: boolean
  /** Published to the loan's participants in the participant portal. */
  participant?: boolean
  createdBy?: string
  uploadedByBorrower?: boolean
  fileOrigin?: string
}

export enum AllowCashOutType {
  YES = '1',
  YES_WITH_RESTRICTION = '2',
  YES_WITH_REQUIREMENT = '3',
  NO = '4',
}

export const AllowCashOutTypeText: Record<AllowCashOutType, string> = {
  [AllowCashOutType.YES]: 'Yes',
  [AllowCashOutType.YES_WITH_RESTRICTION]: 'Yes, W/ % Restriction on Cash Out',
  [AllowCashOutType.YES_WITH_REQUIREMENT]: 'Yes, W/ % Requirement on Assets',
  [AllowCashOutType.NO]: 'No',
}

export interface ILoanSubmissionConditionAiHistoryData {
  fileKey: string
  name: string
  status: string
  note: string
  ai?: IAIPromptHistoryData
}

export interface ILoanSubmissionConditionAiHistory {
  id: number

  data: ILoanSubmissionConditionAiHistoryData[]

  createdBy: string

  createdAt: string
}

export interface IReviewStatus {
  status: number // 0: Pending, 1: Completed
  requestDate: string // Request date
  requestBy: string // Request by

  completeDate?: string // Complete date
  completeBy?: string // Complete by
  note?: string // Completed Note
}

export interface IConditionReviewNo {
  no: number
  key: string
  title: string
  repeat?: number
}
